import TrendingContent from './TrendingContent';

export default TrendingContent;
